import Button from "./Button";

export default function SecondaryButton(props) {
	return <Button {...props} />;
}
